<template>
    <div class="calendar-month">
        <div class="calendar-month__title">
            {{ getMonth(month) }}
        </div>
        <div class="calendar-month__day">
            <div>{{ $t('calendar.day.sunday') }}</div>
            <div>{{ $t('calendar.day.monday') }}</div>
            <div>{{ $t('calendar.day.tuesday') }}</div>
            <div>{{ $t('calendar.day.wednesday') }}</div>
            <div>{{ $t('calendar.day.thursday') }}</div>
            <div>{{ $t('calendar.day.friday') }}</div>
            <div>{{ $t('calendar.day.saturday') }}</div>
        </div>
        <div class="calendar-month__date">
            <template v-for="(date, index) in dateList">
                <div v-if="!index" class="calendar-month__date__item"
                     :key="date.date"
                     :class="{ 'is-day-off': date.isDayOff, 'is-current': date.isCurrent }"
                     :style="{marginLeft: `${firstDay * 14.28571428571429}%`}">
                    {{ date.date }}
                </div>
                <div v-else class="calendar-month__date__item"
                     :key="date.date" :class="{ 'is-day-off': date.isDayOff, 'is-current': date.isCurrent }">
                    {{ date.date }}
                </div>
            </template>
        </div>
    </div>
</template>

<script>
  import { MONTH_LIST } from '@/config'

  export default {
    name: "DayOffCalendarMonth",
    props: ['month', 'year', 'offDateList', 'currentDate'],
    data: function () {
      return {
        dateList: [],
        firstDay: null
      }
    },
    created: function () {
      let startDate = `${this.year}-${this.numberFormat(this.month)}-01`
      let endDate  = this.$moment(startDate).add(1, 'months').subtract(1, 'days').format('YYYY-MM-DD')
      this.firstDay = this.$moment(startDate).format('e')

      while (startDate <= endDate) {
        let date = {
          date: this.$moment(startDate).format('D')
        }

        if (this.offDateList && this.offDateList.indexOf(startDate) !== -1) {
          date.isDayOff = true
        }

        if (startDate === this.currentDate) {
          date.isCurrent = true
        }

        this.dateList.push(date)
        startDate = this.$moment(startDate).add(1, 'days').format('YYYY-MM-DD')
      }
    },
    mounted: function () {

    },
    computed: {

    },
    methods: {
      numberFormat (number) {
        return number < 10 ? `0${number}` : String(number)
      },
      getMonth (month) {
        return typeof MONTH_LIST[month] !== 'undefined' ? this.$t(`calendar.month.${MONTH_LIST[month]}`) : null
      }
    }
  }
</script>

<style lang="scss">
    .calendar-month {
        float: left;
        width: 30%;
        margin-right: 5%;
        margin-bottom: 5%;
        box-sizing: border-box;

        &:nth-child(3n) {
            margin-right: 0;
        }

        &__title {
            color: #606266;
            background: rgba(0, 0, 0, 0.2);
            line-height: 50px;
            text-align: center;
            border-bottom: 1px solid #fff;
        }

        &__day {
            overflow: hidden;

            > div {
                float: left;
                width: 14.28571428571429%;
                box-sizing: border-box;
                background: rgba(0, 0, 0, 0.2);
                border-right: 1px solid #fff;
                line-height: 35px;

                &:last-child {
                    border-right: none;
                }
            }
        }

        &__date {
            overflow: hidden;
            box-sizing: border-box;
            border: 1px solid rgba(0, 0, 0, 0.2);
            border-top: none;
            min-height: 181px;

            &__item {
                float: left;
                width: 14.28571428571429%;
                line-height: 30px;
                height: 30px;

                &.is-day-off {
                    background: #ff0000;
                    color: #fff;
                }

                &.is-current {
                    font-weight: bold;
                    color: #409EFF;
                }
            }
        }
    }
</style>